import { getToken } from "@/utils/auth";
import { EventSourcePolyfill } from "event-source-polyfill";
import Cookies from "js-cookie";
const TokenKey = "Admin-Token";
import { clearLocalstorageAndSaveRememberMeStatus } from "@/util/index";

const eventSource = {
  namespaced: true,
  state: {
    loginStatusEventSource: null,
    isConnected: false,
  },
  // synchronization
  mutations: {
    setLoginStatusEventSource(state, eventSource) {
      console.log("setLoginStatusEventSource");
      state.loginStatusEventSource = eventSource;
      state.isConnected = true;
      localStorage.setItem("loginStatusEventSource", "true");
    },
    closeLoginStatusEventSource(state) {
      if (state.loginStatusEventSource) {
        state.loginStatusEventSource.close();
        state.loginStatusEventSource = null;
        state.isConnected = false;
        localStorage.removeItem("loginStatusEventSource");
      }
    },
  },
  // asynchronization
  actions: {
    startLoginStatusEventSource({ commit }, { router }) {
      console.log("startEventSource");
      // const isConnected = localStorage.getItem("loginStatusEventSource");
      const eventSource = new EventSourcePolyfill(
        `${window.location.origin}/bosc/api/sse/getSseStream`,
        {
          headers: {
            Authorization: "Bearer " + getToken(),
            token: getToken(),
            "Content-Type": "text/event-stream;charset=UTF-8;",
            "Cache-Control": "no-cache",
            Connection: "keep-alive",
            Accept: "text/event-stream",
          },
          reconnectInterval: 86400000,
          withCredentials: true,
        }
      );
      eventSource.onmessage = (event) => {
        // console.log("Received message:", event.data);
        console.log("eventSource Received message");
        var receivedData = JSON.parse(event.data);
        if (receivedData.code == 402) {
          // that.$message.error(receivedData.msg);
          console.error(receivedData.msg);
          // 清除所有 cookies
          const cookies = document.cookie.split(";");
          for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie =
              name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
          }
          // 清除 sessionStorage
          sessionStorage.clear();
          // 清除 localStorage
          // localStorage.clear();
          clearLocalstorageAndSaveRememberMeStatus();
          Cookies.remove(TokenKey);
          commit("closeLoginStatusEventSource");
          router.push(`/login`);
          setTimeout(() => {
            window.history.go(0);
          }, 200);
        }
      };
      eventSource.onerror = (event) => {
        console.log("Received message:", event);
      };
      commit("setLoginStatusEventSource", eventSource);
    },
    stopEventSource({ commit }) {
      commit("closeLoginStatusEventSource");
    },
  },
};
export default eventSource;
